import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from 'react-aria-components';
import { NavigateRoutes } from '@features/routing/routesObject';
import { Grid } from '@pages/admin/article-list/grid/Grid';



export const ArticleList = () => {
	const { t } = useTranslation('admin');
	const navigate = useNavigate();

	return (
		<div className="app-page admin-page article-list-page">
			
			<h1>{t('pages.articleList.header')}</h1>
			
			<Grid />

			<div className='new-article-button'>
				<Button
					className='app-admin-button disable-selection'
					onPress={() => navigate(NavigateRoutes.article)}>
					{t('pages.articleList.newButton')}
				</Button>
			</div>

		</div>
	);
};